
import ResourceSvc from '@/services/resource.svc.js';
const svc = new ResourceSvc();

export default {
    name: 'ThankYouPage',
    components: {
    },
    data() {
        return {
            id: 0,
            name: '',
        }
    },
    computed: {
        courseId() {
            return this.$route.params.id;
        },
        juniorId() {
            if ((new URL(window.location.href)).searchParams.get('registerId')) {
                return (new URL(window.location.href)).searchParams.get('registerId');
            }
            else {
                return 0;
            }
        }
    },
    methods: {
    },
    created() {
    }
}




// WEBPACK FOOTER //
// ./src/components/user/courses/course-details/thank-you-page/thank-you-page.js